/*
 * @Author: 肖玲
 * @Date: 2023-02-17 15:16:46
 * @LastEditTime: 2023-02-17 18:47:30
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\learning-platform\system-settings\modules\systemSettingRouter.js
 * 系统配置
 */
const systemSettingRouter = [
  // 学习平台 系统设置
  {
    path: '/studyPlatform/system-settings',
    name: 'studyPlatformSystemSettings',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformSystemSettings" */
      //   '@/views/studyPlatform/systemSettings.vue'
      // ),
      import(
        /*webpackChunkName:"studyPlatformSystemSettings" */
        '@/views/learning-platform/system-settings/system-setting/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '系统设置',
    },
  },
  // 学习平台 资料库内容设置
  {
    path: '/studyPlatform/data-bank-set/:id',
    name: 'studyPlatformDataBankSet',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformDataBankSet" */
      //   '@/views/studyPlatform/dataBankSet.vue'
      // ),
      import(
        /*webpackChunkName:"studyPlatformDataBankSet" */
        '@/views/learning-platform/system-settings/system-setting/database-content-settings/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '资料库内容设置',
      breadcrumb: [{
        title: '系统设置',
        name: 'studyPlatformSystemSettings',
      }, ],
    },
  },
  // 操作日志 学习平台
  {
    path: '/studyPlatform/operation-log/:meta_type',
    name: 'studyPlatformOperationLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"studyPlatformOperationLog" */
      //   '@/views/masterDataSystem/OperationLog.vue'
      // ),
      import(
        /*webpackChunkName:"studyPlatformOperationLog" */
        '@/views/learning-platform/system-settings/operation-log/page.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '操作日志',
    },
  },
]
export default systemSettingRouter